import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useInriStore } from '../stores/inriStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const inriStore = useInriStore()

const icon = computed(() => {
  return inriStore.state.showSidebar ? 'mdi-fullscreen' : 'mdi-fullscreen-exit'
})

return (_ctx: any,_cache: any) => {
  const _component_c_tile_btn = _resolveComponent("c-tile-btn")!

  return (_openBlock(), _createBlock(_component_c_tile_btn, {
    "data-id": "toggle-sidebar-btn",
    icon: _unref(icon),
    "tooltip-left": _ctx.$t('inri.toggle_actions.sidebar'),
    onClick: _unref(inriStore).toggleSidebar
  }, null, 8, ["icon", "tooltip-left", "onClick"]))
}
}

})